class ExampleSnippet {
  constructor(element) {
    this.element = element;
    this.init();
  }
  init() {
    console.log("SNIPPET EXAMPLE INIT");
  }
}
const exampleSnippet = {
  init() {
    const exampleElements = document.querySelectorAll('[data-snippet="example"]');
    if (null !== exampleElements && exampleElements.length > 0) {
      exampleElements.forEach((element) => {
        new ExampleSnippet(element);
      });
    }
  }
};
document.addEventListener("DOMContentLoaded", () => {
  exampleSnippet.init();
});
